import React from "react";

export default function BelowNavbar() {
  return (
    <div className="belowNav">
      {/* <img src="/Images/Rectangle 426.png" alt="rectangle" /> */}
      <img
        src="https://assets.oyoroomscdn.com/cmsMedia/f0be8dc3-e384-40b3-89f9-a0a0109159ce.jpg"
        alt="rectangle"
      />
    </div>
  );
}
